export enum ContextType {
  HOLIDAY = 'HOLIDAY',
  CALENDAR = 'CALENDAR',
  CONSTRUCTION = 'CONSTRUCTION',
  STRATEGY = 'STRATEGY',
  OBSTRUCTION = 'OBSTRUCTION',
  NOTIFICATION = 'NOTIFICATION',
}
